import '../scss/style.scss';

import * as $ from 'jquery';
import lozad from 'lozad';

//Lazyload
const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();

$(function () {
    initScripts();
});

function initScripts() {
    function timer() {
        let timerElement = $('.congratulation-timer');
        if (!timerElement.length) {
            return;
        }
        let timerValue = timerElement.attr('data-value');
        let interval = setInterval(function() {
            let timeArray = timerValue.split(':');
            let minutes = parseInt(timeArray[0], 10);
            let seconds = parseInt(timeArray[1], 10);

            seconds--;
            if (seconds < 0) {
                minutes--;
                if (minutes < 0) {
                    clearInterval(interval);
                    timerElement.hide();
                    $('.congratulation-decision-text').hide();
                    return;
                }
                seconds = 59;
            }

            minutes = (minutes < 10) ? '0' + minutes : minutes;
            seconds = (seconds < 10) ? '0' + seconds : seconds;

            timerElement.html(minutes + ':' + seconds);
            timerValue = minutes + ':' + seconds;
        }, 1000);
    }

    function showLinkPreloader(currLink) {
        $(currLink).css('pointer-events', 'none');
        $(currLink).find('span').addClass('hide');
        $(currLink).find('.lds-ellipsis').removeClass('hide');
    }

    function hideLinkPreloader(currLink) {
        $(currLink).css('pointer-events', 'auto');
        $(currLink).find('span').removeClass('hide');
        $(currLink).find('.lds-ellipsis').addClass('hide');
    }

    function getLink() {
        $(".offerButton").click(function (event) {
            event.preventDefault();

            const offerId = $(this).data("offer-id");
            const currentDomain = window.location.origin;
            const apiUrl = `${currentDomain}/api/click/send?offerId=${offerId}`;
            const currLink = this;
            showLinkPreloader(currLink);

            $.ajax({
                url: apiUrl,
                method: "GET",
                timeout: 30000,
                success: function (response) {
                    if (response.status === "success" && response.link) {
                        hideLinkPreloader(currLink);

                        // Обрабатываем ссылку в зависимости от браузера
                        const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
                        const isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
                        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

                        if (isChrome || isFirefox) {
                            // Открываем ссылку в новой вкладке
                            window.open(response.link, "_blank");
                        } else if (isIOS) {
                            // Для iOS используем window.open с задержкой
                            setTimeout(() => {
                                window.open(response.link, "_blank");
                            }, 100);
                        } else if (isSafari) {
                            // Для Safari создаем элемент ссылки и запускаем его кликом
                            const a = document.createElement("a");
                            a.setAttribute("href", response.link);
                            a.setAttribute("target", "_blank");
                            a.click();
                            a.remove();
                        } else {
                            // Для других браузеров открываем ссылку в новой вкладке
                            window.open(response.link, "_blank");
                        }
                    } else {
                        hideLinkPreloader(currLink);
                        console.error("Error: invalid response");
                    }
                },
                error: function (error) {
                    hideLinkPreloader(currLink);
                    console.error(error);
                },
            });
        });
    }

    function randomTexts() {
        let texts = {
            'Поздравляем! Вам одобрены займы в этих компаниях': 'Отправьте заявку как минимум в 3 компании, чтобы быстрее получить деньги',
            'Возьмите займ онлайн под 0%!': 'Отправьте заявку в 2-3 компании для получения нужной вам суммы',
            'Подобрали предложения специально для вас!': 'Заполните максимальное количество заявок - получите деньги прямо сейчас',
            'Получите нужные вам деньги': 'Гарантируем выдачу займа при заполнении трех и более заявок в этих МФО',
            'Займ одобрен': 'Отправьте 3-4 заявки в несколько компаний'
        }

        let entries = Object.entries(texts);
        let randomEntryIndex = Math.floor(Math.random() * entries.length);
        let randomEntry = entries[randomEntryIndex];
        let [randomKey, randomValue] = randomEntry;

        $('.congratulation-title').text(randomKey);
        $('.congratulation-description').text(randomValue);
    }

    timer();
    getLink();
    randomTexts();
}